import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, FabContainer, LoadingController, AlertController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import moment from 'moment'
import { DetallePage } from '../detalle/detalle';

/**
 * Generated class for the ReportePedidosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reporte-pedidos',
  templateUrl: 'reporte-pedidos.html',
})
export class ReportePedidosPage {
  pedidos: any = []
  vendedor: any
  vendedores: any = []
  loadModal: any
  buscado: any = false
  fecha: any = moment().format('YYYY-MM-DD')
  selectTitleVendedor: any = {
    title: 'Vendedores',
  }
  super: any = false
  constructor(
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public alertCrtl: AlertController,
    public http: HttpProvider,
    public navParams: NavParams,
    public modalSrv: ModalController
    ) {
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  ionViewDidEnter() {
    if(window.localStorage.getItem('network') === '1') {
      if(window.localStorage.getItem('super')){
        this.super = true
      }else{
        this.vendedor = window.localStorage.getItem('co_ven')
      }
      if (this.super) {
        this.ActivarLoading()
        this.http.get(`vendedor/supSinDeuda?vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
          (res: any) => {
            this.vendedores = res
            this.DesactivarLoading()
          }, 
          err => {
            this.DesactivarLoading()
            console.log(err)
          }
        )
      }
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  verPedido(cod, fab: FabContainer){
    fab.close()
    this.navCtrl.push(DetallePage,{pedido:cod})
  }

  buscar() {
    this.buscado = false
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.get(`pedidosCom/vend/date/${this.vendedor.replace(/ /g,'')}?fecha=${this.fecha}`).subscribe(
        (res:any)=>{
          this.pedidos = res
          if (this.pedidos.length === 0) this.buscado = true 
          this.DesactivarLoading()
        },
        error=>{
          this.DesactivarLoading()
          this.buscado = true
          console.log(error)
        }
      )
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/reporte-pedidos/reporte-pedidos.ts